module.exports = __webpack_public_path__ + "media/images/lb/802-3550b64ea8070a41ccee2b70b4443e9a.svg";